import { writable } from 'svelte/store';
import dayjs from 'dayjs';
export const currentUser = writable(null);
export const currentClientWebsite = writable(null);
export const cache = writable({});
export const dateFormat = 'YYYY-MM-DD';

export const formatNumber = (value, format) => {
	if (format == 'percent') {
		return `${Math.round(value * 100)}%`;
	} else {
		return value;
	}
};

export const getLastXDays = (x, format) => {
	return {
		startDate: dayjs(new Date()).subtract(x, 'days').format(format),
		endDate: dayjs(new Date()).format(format)
	};
};
